import { colors } from './styles';

export const lightTheme = {
    backgroundColor: colors.white, 
    color: colors.black,
    titleColor: colors.gray900, 
    itemColor: colors.gray50
  };
  
  export const darkTheme = {
    backgroundColor: colors.gray900,
    color: colors.gray50,
    titleColor: colors.gray50, 
    itemColor: colors.gray50
  };
  